<template>
  <!--附件下载弹出框-->
  <el-dialog
    :visible.sync="downloadAttachmentVisible"
    title="附件下载"
    :append-to-body="true"
    :close-on-click-modal="false"
    custom-class="customWidthDownloadAttachment"
  >
    <div>
      <!-- table start -->
      <el-row style="margin-top: 15px;margin-bottom: 20px">
        <hot-table
          ref="mdAccessoriesTableRef"
          :data-source="mdAccessoriesTableDataSource"
          :settings="mdAccessoriesTableSettings"
          col-settings-key="mdAccessories"
        >
          <hot-column :has-tip="true" data="mdAccessoriesId" title="操作" width="70">
            <column_download_renderer hot-renderer @clickModule="clickModule"></column_download_renderer>
          </hot-column>
          <hot-column :has-tip="true" data="attachmentName" title="文件名" width="160"></hot-column>
          <hot-column :has-tip="true" data="documentName" title="文件类型" width="150"></hot-column>
        </hot-table>
        <!-- 分页start -->
        <div class="pg_div">
          <el-pagination
            :current-page="pageConfig.currentPage"
            :layout="pageConfig.layout"
            :page-size="pageConfig.pageSize"
            :page-sizes="pageConfig.pageSizes"
            :total="pageConfig.total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
        <!-- 分页end -->
      </el-row>
      <!-- table end -->
    </div>
  </el-dialog>
</template>

<script>

  import columnDownloadRenderer from "@/components/CustomRenderer/columnDownloadRenderer"

  export default {
    components: {
      column_download_renderer: columnDownloadRenderer,
    },
    name: 'downloadAttachmentUpBox',
    props: {
      downloadAttachmentVisibleFlagInit: Boolean,
      ebOrder: {}
    },
    data() {
      return {
        downloadAttachmentVisible: false,
        mdAccessories: {
          ebAttachmentType: "",
          ebType: "O",
          file: ""
        },
        // 表格数据
        mdAccessoriesTableDataSource: [],
        // 表格设置
        mdAccessoriesTableSettings: {
          height: 150,
          stretchH: 'all', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
          ...this.$systemConfig.tableConfig,
          showSelection: false //把checkBox隐藏
        },
        // 分页
        pageConfig: {
          layout: 'total, sizes, prev, pager, next, jumper',
          total: 0,
          pageSize: 10,
          pagerCount: 10,
          currentPage: 1,
          pageSizes: [10, 20, 50, 100]
        },
      }
    },
    // 监听
    watch: {
      downloadAttachmentVisibleFlagInit() {
        let self = this
        self.downloadAttachmentVisible = true
        this.queryMdAccessories()
      }
    },
    created() {
    },
    mounted() {

    },
    methods: {
      // pageSize 改变时会触发
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`)
        this.pageConfig.pageSize = val
        let self = this
        self.queryMdAccessories()
      },
      // currentPage 改变时会触发
      handleCurrentChange(val) {
        this.pageConfig.currentPage = val
        let self = this
        self.queryMdAccessories()
      },
      //获取表格数据
      queryMdAccessories() {
        let self = this
        console.log("ebOrder", self.ebOrder)
        self.mdAccessoriesTableDataSource = [
          {mdAccessoriesId: 4, documentName: "IFTMBF(订舱申请)", attachmentName: "OOLU201038577"},
          {mdAccessoriesId: 5, documentName: "IFTMBC(订舱确认)", attachmentName: "OOLU201038522"},
          {mdAccessoriesId: 6, documentName: "IFTMBF(订舱申请)", attachmentName: "OOLU201038534"}]
        self.pageConfig.total = 3
        console.log("mdAccessoriesTableDataSource", self.mdAccessoriesTableDataSource)
      },
      //子组件
      clickModule() {

      }
    }
  }
</script>

<style>
  .customWidthDownloadAttachment {
    width: 40%;
    height: 300px;
  }

  .el-dialog__body {
    padding: 0px;
  }

</style>
